import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './utils/msalConfig';
import AuthWrapper from './components/AuthWrapper';
import App from './App';

msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise().then(() => {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <AuthWrapper>
            <App />
          </AuthWrapper>
        </MsalProvider>
      </React.StrictMode>
    );
  }).catch(err => {
    console.error('Redirect handling failed:', err);
  });
});
